import './Body.css'
import Header from './Header.js'
import Cb2 from './box2.js';
function Body(){
    return (
        <div className="body">
            <Header/>
            <Cb2></Cb2>
        </div>
    );
}
export default Body;